import { Box, IconButton } from '@chakra-ui/react'
import { FC } from 'react'
import { BiSortAlt2, BiSortDown, BiSortUp } from 'react-icons/bi'
import { VscSettingsGear } from 'react-icons/vsc'

import './styles.css'
import useTableScrollProductSimilar from '@hook/shared/use-table-product-similar-scroll'

interface ITableGridHeader {
  selected?: any
  isModal?: boolean
  isActions?: boolean
  updateIsModalConfig?: () => void
}

const TableGridHeader: FC<ITableGridHeader> = ({
  isModal,
  selected,
  isActions = true,
  updateIsModalConfig
}) => {
  const { actions, columns, handleOrder, order, itsSortableGroup } =
    useTableScrollProductSimilar()

  const handleMouseDown = (event: any) => {
    const widthElement = event.target.getBoundingClientRect()?.width

    document.querySelectorAll('.td-element').forEach((item: any) => {
      if (event.target.id === item.id) {
        item.style.width = '100%'
        item.style.minWidth = '0px'
        item.style.maxWidth = '0px'
        item.style.whiteSpace = 'nowrap'
        item.style.overflow = 'hidden'
        item.style.textOverflow = 'ellipsis'

        item.children[0].style.overflow = 'hidden'
        item.children[0].style.textOverflow = 'ellipsis'
      }
    })

    event.target.style.width = `${widthElement}px`
  }

  return (
    <thead
      style={{
        background: '#EDF2F7',
        position: 'sticky',
        top: 0,
        zIndex: 1
      }}
    >
      <tr className="actions">
        {isActions && actions && actions.length > 0 && (
          <td rowSpan={2}>
            {selected && isModal ? (
              <Box>
                <IconButton
                  aria-label="Time"
                  size="md"
                  icon={<VscSettingsGear />}
                  color="gray.700"
                  fontSize="18px"
                  transition="all ease .3s"
                  onClick={updateIsModalConfig}
                  _hover={{
                    bgColor: 'gray.300'
                  }}
                  actions
                  _active={{
                    bgColor: 'gray.500'
                  }}
                />
              </Box>
            ) : (
              'Ações'
            )}
          </td>
        )}
        {columns.map(item => {
          if (!item.id) {
            return (
              <th
                color="gray.700"
                key={`${item.group
                  .split(' ')
                  .join('-')
                  .toLocaleLowerCase()!}-header`}
                colSpan={item.columns!.length}
                scope="colgroup"
              >
                {item.group}
              </th>
            )
          }

          return (
            <td
              color="red"
              rowSpan={2}
              key={item.id + '+header'}
              align={item.align || 'left'}
            >
              {itsSortableGroup && (
                <IconButton
                  aria-label="Order"
                  icon={
                    order.column !== item.id ? (
                      <BiSortAlt2 />
                    ) : order.sort === 'asc' ? (
                      <BiSortUp />
                    ) : (
                      <BiSortDown />
                    )
                  }
                  size="xs"
                  mr={2}
                  onClick={() => {
                    handleOrder(item.id)
                  }}
                />
              )}
              {item.group}
            </td>
          )
        })}
      </tr>
      <tr className="hearder__th">
        {columns.map(item => {
          const { align, columns } = item

          return columns!.map(column => (
            <th
              className="hearder__th"
              key={`${column.id}-header`}
              align={align || 'left'}
              scope="col"
            >
              <Box
                id={column.id}
                className="hearder__text-container"
                onMouseDownCapture={event => handleMouseDown(event)}
              >
                {/* {itsSortable && (
                  <IconButton
                    aria-label="Order"
                    icon={
                      order.column !== column.id ? (
                        <BiSortAlt2 />
                      ) : order.sort === 'asc' ? (
                        <BiSortUp />
                      ) : (
                        <BiSortDown />
                      )
                    }
                    size="xs"
                    mr={2}
                    onClick={() => {
                      handleOrder(column.id)
                    }}
                  />
                )} */}

                <span className="hearder__text">{column.name}</span>
              </Box>
            </th>
          ))
        })}
      </tr>
    </thead>
  )
}

export default TableGridHeader
